import React, {
  useLayoutEffect,
  useMemo,
  useRef,
} from 'react';

import {
  Outlet,
  useLocation,
} from 'react-router-dom';

import {
  useAuth,
} from '../../../features/auth/AuthContext';

import AppHeader
  from '../AppHeader';

import {
  getNavigationItemsByRole,
} from '../../../config/navigationConfig';

import {
  ROUTES,
} from '../../../config/routes';

import './MainLayout.css';
import './PortalTheme.css';


export default function MainLayout({
  children,
}) {
  const {
    user,
  } =
    useAuth();

  const location =
    useLocation();

  const contentRef = useRef(null);
  const previousPathRef = useRef(location.pathname);

  useLayoutEffect(() => {
    const previousPath = previousPathRef.current;
    previousPathRef.current = location.pathname;

    if (
      previousPath === location.pathname ||
      location.pathname === ROUTES.root ||
      location.hash ||
      (previousPath.startsWith('/updatenotices') &&
        location.pathname.startsWith('/updatenotices')) ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
      !contentRef.current?.animate
    ) {
      return undefined;
    }

    const animation = contentRef.current.animate(
      [
        { transform: 'translateY(-80px)', opacity: 0 },
        { transform: 'translateY(0)', opacity: 1 },
      ],
      {
        duration: 450,
        easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
      },
    );

    return () => animation.cancel();
  }, [location.pathname, location.hash]);

  const userRole =
    user?.role ||
    user?.userRole ||
    'USER';

  const navigationItems =
    useMemo(
      () =>
        getNavigationItemsByRole(
          userRole,
        ),
      [
        userRole,
      ],
    );

  const isHomePage =
    location.pathname ===
    ROUTES.root;

  return (
    <div
      className="main-layout"
    >
      <AppHeader
        items={
          navigationItems
        }
      />

      <div
        className="main-layout-body"
      >
        <main
          ref={contentRef}
          className={[
            'main-layout-content',
            isHomePage
              ? 'is-home'
              : '',
          ]
            .filter(Boolean)
            .join(' ')}
        >
          {children || <Outlet />}
        </main>
      </div>
    </div>
  );
}
